import { Menu, MenuItem } from '@mui/material';
import styled from 'styled-components';
import { mixins, fonts, media } from '../../../../css';

export const StyledMenuItem = styled(MenuItem)`
  && {
    ${({ theme }) => `background-color: ${theme.darkerTheme}`};
    ${({ theme }) => `color: ${theme.lightText}`};
    font-family: ${fonts.fontRegular};
    font-size: ${mixins.pxToRem(14)};
    &&[class^='MuiMenuItem-selected'] {
      ${({ theme }) => `background-color: ${theme.darkestTheme}`};
    }
  }
`;

export const StyledMenu = styled(Menu)`
  &&&& {
    div[class^='MuiPaper-root'] {
      ${({ theme }) => `background-color: ${theme.darkerTheme}`};
      ${({ theme }) => `color: ${theme.lightText}`};
      width: 100%;
      ${media.greaterThan('lg')`max-width: ${mixins.pxToRem(260)}; margin-left: ${mixins.pxToRem(20)};`};
    }
  }
`;

export const StyledMenuLabel = styled.div`
  margin: ${mixins.pxToRem(10)} 0;
  border-top: 0.5px solid;
  border-bottom: 0.5px solid;
  ${({ theme }) => `border-top-color: ${theme.darkestTheme}`};
  ${({ theme }) => `border-bottom-color: ${theme.darkestTheme}`};

  cursor: pointer;
  font-size: ${mixins.pxToRem(14)};
  ${({ theme }) => `color: ${theme.lightText}`};
  font-family: ${fonts.fontRegular};
  text-decoration: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${mixins.pxToRem(15)} ${mixins.pxToRem(25)};

  &:hover {
    ${({ theme }) => `background-color: ${theme.mainTheme}`};
  }

  figure {
    cursor: pointer !important;
  }

  ${media.greaterThan('lg')`flex-flow: row nowrap; align-items: center; justify-items: center; height: 100%;`};
`;
